const BaseFilter = require("app/components/filters/SelectFilter");
const productsApi = require("app/pipelines/products-api");

class OrderFilter extends BaseFilter {

	get options() {
		return [
			{
				title: translate("Mest populære"),
				value: "popularity"
			},
			{
				title: translate("Laveste pris"),
				value: "price_low"
			},
			{
				title: translate("Højeste pris"),
				value: "price_high"
			}
		];
	}

	get defaultValue() {
		return "popularity";
	}

	componentDidMount() {
		productsApi.request.pipe(payload => {
			payload.$order = this.value;
			return payload;
		});
	}

	onChange() {
		productsApi.request.dispatch();
	}

}

module.exports = OrderFilter;
